import {Contact, ContactId} from '@api';
import {normalize} from 'normalizr';
import {ContactSchema, ContactsState} from 'src/js/NormalizeSchema';
import {IAction} from 'src/js/actions/IshAction';
import {ContactState} from 'src/js/services/IshState';

export const SUBMIT_ADD_CONTACT = 'checkout/submit/add/contact';

export const ADD_PAYER_FROM_VOUCHER = 'checkout/add/payer/from/voucher';

export const ADD_CONTACT_TO_STATE = 'checkout/add/contact/to/state';

export const CONTACT_ADD_FORM_NAME = 'ContactAddForm'

export const COMPANY_ADD_FORM_NAME = 'CompanyAddForm';

export interface Values {
  firstName: string;
  lastName: string;
  email: string;
  company?: boolean;
}

const getContactPayload = (contactId, values): SubmitContact => {
  const contact: Contact = {
    id: contactId.id,
    firstName: values.firstName,
    lastName: values.lastName,
    email: values.email,
  }

  return {
    contact,
    newContact: contactId.newContact,
    parentRequired: contactId.parentRequired,
    updateData: values.updateData
  };
};


export interface SubmitContact {
  contact: Contact;
  newContact: boolean;
  parentRequired?: boolean;
  updateData?: boolean;
  parent?: Contact;
}

export const submitAddContact = (contactId: ContactId, values: Values): IAction<SubmitContact> => {
  return {
    type: SUBMIT_ADD_CONTACT,
    payload: getContactPayload(contactId, values),
    meta: {
      from: CONTACT_ADD_FORM_NAME,
    },
  };
};

export const addPayerFromVoucher = (contact: Contact): IAction<SubmitContact> => {
  return {
    type: ADD_PAYER_FROM_VOUCHER,
    payload: {contact, newContact: false},
    meta: {
      from: CONTACT_ADD_FORM_NAME,
    },
  };
};

export const addContact = function (contact: ContactState): { type: string, payload: ContactsState } {
  return {type: ADD_CONTACT_TO_STATE, payload: normalize(contact, ContactSchema)};
};
